import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

// Plugins
import { vuetify } from "./plugins";
import { initAppInsights } from "./plugins/appInsights";

const pinia = createPinia();
const app = createApp(App);

// Application Insights: monitoramento de erros e uso no navegador
initAppInsights(app);

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(i18n);

// Montamos o aplicativo diretamente, pois a inicialização do auth
// agora será feita no componente App.vue
app.mount("#app");
